import {
  EditOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  SearchOutlined,
  StarFilled,
  StarOutlined,
} from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import React, { useContext } from "react";
import { Link, createSearchParams } from "react-router-dom";
import { setfarmerMarked } from "../../../service/api";
import { useQueryClient } from "@tanstack/react-query";
import FarmerFilterContext from "../../../context/farmerFilterContext";

function Farmers({ farmer }) {
  const queryClient = useQueryClient();
const { fullName,
  phoneNumber,
  provinceId,
  cityId,
  productId,
  marked,
  sort} = useContext(FarmerFilterContext)
  const mutation = useMutation(setfarmerMarked, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "farmers"
        ],
      });
      queryClient.invalidateQueries({ queryKey: ["farmerInfo"] });
    },
  });

  const firstName = farmer?.farmer?.firstName;
  const farmerPhoneNumber = farmer?.farmer?.phoneNumber;
  const lastName = farmer?.farmer?.lastName;
  const province = farmer?.farmer?.province;
  const city = farmer?.farmer?.city;
  const questionnairesCount = farmer?.questionnairesCount;
  const visitCount = farmer?.visitsCount;
  const starMarked = farmer?.marked;
  const farmerId = farmer?.farmerId;
  const avatarUrl =process.env.REACT_APP_ARVAN_S3_BASE_URL + farmer?.farmer?.avatar;
  return (
    <>
      <div className="p-2 whitespace-nowrap bg-white rounded-[15px]  max-sm:p-1 max-sm:w-full shadow-[4px_4px_20px_-8px_rgba(0,0,0,0.15)]  flex flex-row items-center justify-between hover:cursor-pointer hover:shadow-xl max-sm:flex-col max-sm:gap-3  ">
        <Link
          to={{
            pathname: "farmer-info",
            search: createSearchParams({ farmerId: farmerId }).toString(),
          }}
          className="flex flex-row items-center gap-4 w-1/3 max-sm:w-full max-sm:gap-9"
        >
          <div className="   rounded-full overflow-hidden w-20  ">
            <img alt="avatar" src={avatarUrl} />
          </div>
          <p>
            {firstName} {lastName}
          </p>
        </Link>
        <section className="flex flex-row w-[36rem] justify-between px-6 max-sm:w-full max-sm:text-[0.6875rem] max-sm:gap-2 ">
          <div className="flex flex-row gap-1 ">
            <EnvironmentOutlined />
            <p>
              {province} {city}
            </p>
          </div>
          <div className="flex flex-row gap-1">
            <EditOutlined />
            <p>{questionnairesCount}</p>
            <p>برنامه کودی</p>
          </div>
          <div className="flex flex-row gap-1">
            <SearchOutlined />
            <p>{visitCount}</p>
            <p>بازدید</p>
          </div>
        </section>
        <section className="flex flex-col gap-5 text-3xl max-sm:flex-row-reverse max-sm:justify-between  max-sm:w-full max-sm:gap-0">
          {starMarked ? (
            <StarFilled
              onClick={() =>
                mutation.mutate({ farmerId: farmerId, marked: false })
              }
              className="text-yellow-300 text-4xl"
            />
          ) : (
            <StarOutlined
              onClick={() =>
                mutation.mutate({ farmerId: farmerId, marked: true })
              }
              className="text-4xl"
            />
          )}
          <a href={"tel:" + farmerPhoneNumber}>
            <PhoneOutlined className="bg-green-400 p-1 rounded-xl text-white" />
          </a>
        </section>
      </div>
    </>
  );
}
// export function FarmerPagination() {
//   return (
//     <div>
//       <Routes>
//         <Route path="farmerId/*" element={<SelectedFarmer/>}>
//           <Route path="showAllPlans"/>
//           <Route path="showAllVisit" element={<AllVisit/>}/>
//         </Route>
//       </Routes>
//     </div>
//   );
// }

export default Farmers;
